module.exports = __webpack_public_path__ + "static/media/officeImg4.c8561457.png";